import React, { Component } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';

export class ScheduleSection extends Component {
  static displayName = ScheduleSection.name;

  schedules = [
    {
      day: "Domingos",
      times: ["7:00 AM", "9:00 AM", "11:00 AM"],
      description: "Cultos principales de adoración y predicación"
    },
    {
      day: "Miércoles",
      times: ["6:30 PM"],
      description: "Estudio bíblico y oración"
    },
    {
      day: "Viernes",
      times: ["7:00 PM"],
      description: "Vigilia"
    },
    {
      day: "Sábados",
      times: ["6:00 AM"],
      description: "Ayuno"
    },
    {
      day: "Sábados",
      times: ["6:00 PM"],
      description: "Grupo de jóvenes"
    }
  ];

  render() {
    return (
      <section id="schedule" className="section" style={{ backgroundColor: 'var(--light-cream)' }}>
        <Container>
          <h2 className="section-title">Horarios de Cultos</h2>
          <Row>
            <Col lg="8" className="mx-auto">
              <div className="text-center mb-5">
                <h4 style={{ color: 'var(--dark-blue)' }}>
                  📍 Santa Marta, Magdalena
                </h4>
                <p className="lead">
                  Cra 4 #11a-38 Rodadero, Magdalena, Colombia
                </p>
              </div>
            </Col>
          </Row>
          
          {/* Mapa de Google Maps */}
          <Row className="mb-5">
            <Col lg="10" className="mx-auto">
              <div className="map-container" style={{ 
                borderRadius: '15px', 
                overflow: 'hidden',
                boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                marginBottom: '2rem'
              }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.5!2d-74.2!3d11.2!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef4f5a5a5a5a5a5%3A0x5a5a5a5a5a5a5a5a!2sCra%204%20%2311a-38%2C%20Rodadero%2C%20Gaira%2C%20Magdalena%2C%20Colombia!5e0!3m2!1ses!2sco!4v1234567890123!5m2!1ses!2sco"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación de la Iglesia CBR - Centro Bíblico Rodadero"
                ></iframe>
              </div>
              
              {/* Información adicional del mapa */}
              <div className="row text-center">
                <div className="col-md-4 mb-3">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--primary-blue)', fontSize: '1.2rem' }}></i>
                    <div>
                      <strong>Dirección Exacta</strong><br />
                      <small className="text-muted">Cra 4 #11a-38 Rodadero</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="fas fa-car me-2" style={{ color: 'var(--secondary-gold)', fontSize: '1.2rem' }}></i>
                    <div>
                      <strong>Estacionamiento</strong><br />
                      <small className="text-muted">Disponible en el lugar</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="fas fa-bus me-2" style={{ color: 'var(--accent-blue)', fontSize: '1.2rem' }}></i>
                    <div>
                      <strong>Transporte Público</strong><br />
                      <small className="text-muted">Fácil acceso en bus</small>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            {this.schedules.map((schedule, index) => (
              <Col lg="6" md="6" className="mb-4" key={index}>
                <Card className="schedule-card h-100">
                  <div className="card-body">
                    <h5 className="card-title" style={{ color: 'var(--dark-blue)' }}>
                      {schedule.day}
                    </h5>
                    <div className="mb-3">
                      {schedule.times.map((time, timeIndex) => (
                        <span 
                          key={timeIndex}
                          className="badge me-2 mb-2" 
                          style={{ 
                            backgroundColor: 'var(--primary-blue)',
                            color: 'white',
                            fontSize: '1rem',
                            padding: '8px 16px'
                          }}
                        >
                          {time}
                        </span>
                      ))}
                    </div>
                    <p className="card-text text-muted">
                      {schedule.description}
                    </p>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          
          {/* Formación */}
          <Row className="mt-5">
            <Col lg="12">
              <h3 className="text-center mb-4" style={{ color: 'var(--dark-blue)' }}>
                Formación Cristiana
              </h3>
            </Col>
            <Col lg="4" className="mb-4">
              <Card className="h-100 text-center">
                <div className="card-body">
                  <i className="fas fa-graduation-cap fa-3x mb-3" style={{ color: 'var(--primary-blue)' }}></i>
                  <h5 className="card-title">Escuela Bíblica</h5>
                  <p className="card-text">
                    Estudios profundos de la Palabra de Dios para todas las edades.
                  </p>
                  <small className="text-muted">
                    Domingos 9:00 AM
                  </small>
                </div>
              </Card>
            </Col>
            <Col lg="4" className="mb-4">
              <Card className="h-100 text-center">
                <div className="card-body">
                  <i className="fas fa-baby fa-3x mb-3" style={{ color: 'var(--secondary-gold)' }}></i>
                  <h5 className="card-title">Escuela Dominical</h5>
                  <p className="card-text">
                    Enseñanza bíblica adaptada para niños y adolescentes.
                  </p>
                  <small className="text-muted">
                    Domingos 9:00 AM
                  </small>
                </div>
              </Card>
            </Col>
            <Col lg="4" className="mb-4">
              <Card className="h-100 text-center">
                <div className="card-body">
                  <i className="fas fa-book-open fa-3x mb-3" style={{ color: 'var(--accent-blue)' }}></i>
                  <h5 className="card-title">Discipulado</h5>
                  <p className="card-text">
                    Crecimiento personal y desarrollo del carácter cristiano.
                  </p>
                  <small className="text-muted">
                    Miércoles 7:00 PM
                  </small>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
